import React from "react";
import Modal from '@mui/material/Modal';
import { Box, Button, Typography, Divider, IconButton } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ScreenView from "../util/screenView";
import success from "../assets/images/success.gif";
import errorIcon from "../assets/images/error.png";

const ModalComponent = React.memo(function ModalComponent({ open, onClose, title, content, contentIdentity, modalResponse }) {
    let screenSize = window.innerWidth;
    const style = {
        position: 'absolute',
        top: '50%',
        left: contentIdentity === 'Verification' && contentIdentity === 'documentPreview' ? '50%' : '56%',
        width: contentIdentity === 'Verification' ? '35%' : contentIdentity === 'alert' || contentIdentity === 'confirmation' ? '35%' : '70%',         
        transform: 'translate(-60%, -50%)',
        border: 'none',
    };

    const mediaQueryStyle = {
        '@media only screen and (max-width: 900px)': {
            position: 'absolute',
            top: '50%',
            left: contentIdentity === 'Verification' && contentIdentity === 'documentPreview' ? '50%' : '47%',
            width: contentIdentity === 'Verification' ? '35%' : contentIdentity === 'alert' || contentIdentity === 'confirmation' ? '75%' : '80%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
        },
    };

    const handleContinue = () => {
        onClose();
        modalResponse();
    }

    const handleCancel = () => {
        onClose();
        // modalResponse(false);
    }

    return (
        <ScreenView>
            {mobileView => (
                <Modal
                    open={open}
                    onClose={onClose}
                >
                    <Box sx={screenSize < 900 ? mediaQueryStyle : style}>
                        <Box className='modal' sx={{
                            width : contentIdentity === 'alert' || contentIdentity === 'confirmation' ? '100%' : 'auto',
                            height: contentIdentity === 'alert' || contentIdentity === 'confirmation' ? '30%' : contentIdentity === 'documentPreview' ? '86vh' : 'auto',
                            borderRadius: '10px',
                            border: 'none',
                            overflowY: 'auto',
                            scrollbarWidth: 'none',
                            background: '#fff',
                            alignItems: 'right',
                            justifyItems: 'right',
                            textAlign: 'right',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            position: 'relative', // Add this for absolute positioning
                            paddingTop: contentIdentity === 'documentPreview' ? '48px' : '0', 
                        }}
                        >
                            {/* Close Button */}
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    // color: '#ffffff',
                                    padding: 0,
                                    color: '#545454ff',
                                    zIndex: 2,
                                }}
                            >
                                <CancelOutlinedIcon />
                            </IconButton>
                            {/* {contentIdentity === 'alert' &&
                                <>
                                    {title === 'Success' ?
                                    <img src={success} style={{ width: '30%' }} alt="success"/> : <img src={errorIcon} style={{ width: '30%' }} alt="error"/>
                                    }
                                </>
                            } */}
                            <Typography sx={{textAlign: 'center', fontWeight: 600, fontSize: 22, fontFamily: 'Open Sauce Sans', 
                                color: contentIdentity === 'Verification' ? '#fff' : '#000',
                                background: contentIdentity === 'Verification' ? 'linear-gradient(119.54deg, #000046 0, #1cb5e0 100%)' : '#fff', 
                                width: '102%', 
                                borderRadius: '10px 10px 0px 0px',
                                marginTop: contentIdentity === 'alert' ? '1%' : '-2%',
                            }}>
                                <b>{title}</b>
                            </Typography>
                            {contentIdentity === 'alert' &&
                                <hr style={{border: '0.5px solid rgb(239 239 239)', width: '100%', margin: '10px 0'}}/>
                            }
                            <Typography className="content" 
                                sx={{
                                    textAlign:  contentIdentity === 'alert' || contentIdentity === 'documentPreview' ? 'left' : 'center', 
                                    color: '#484848', 
                                    mt: contentIdentity === 'confirmation' ? 3 : 1,
                                    ml: contentIdentity === 'Confirmation' ? 0 : 3,
                                    mr: contentIdentity === 'Confirmation' ? 0 : 3,
                                    height: contentIdentity === 'documentPreview' ?? '80vh' 
                                }}
                            >
                                {content}
                                {/* {contentIdentity === 'documentPreview' ? 
                                <iframe src={content} width={700} height={500} frameBorder="0"></iframe>
                                 : {content}} */}
                            </Typography>
                            {contentIdentity !== 'Verification' && contentIdentity !== 'confirmation' && contentIdentity !== 'documentPreview' &&
                                <Box sx={{display: 'flex', gap: 3, mt:3, mb: contentIdentity === 'alert' ? '1%' : '0%'}}>
                                    <Button sx={{
                                         border: '1px solid #D4273C',
                                         color: '#D4273C',
                                         background: '#FFF',
                                         '&:hover': {
                                             border: '1px solid #D4273C',
                                         },
                                         textTransform: 'none',
                                        // textAlign: 'center', 
                                        // borderColor: '#D4273C',
                                        // color: '#fff',
                                        width: '30%',
                                        marginTop:  '3%',
                                        marginBottom: '2%',
                                    }}
                                        onClick={handleCancel}
                                    >Cancel</Button>
                                    <Button sx={{
                                        textAlign: 'center', 
                                        background: '#D4273C',
                                        color: '#fff',
                                        marginTop:  '3%',
                                        marginBottom: '2%',
                                        '&:hover': {
                                            background: '#D4273C',
                                        },
                                        textTransform: 'none',
                                    }}
                                        onClick={handleContinue}
                                    >Delete</Button>
                                </Box>
                            }
                            {contentIdentity === 'confirmation' && 
                                <Box sx={{display: 'flex', mt:3}}>
                                    <Button sx={{
                                        textAlign: 'center', 
                                        background: '#D4273C',
                                        color: '#fff',
                                        marginTop:  '3%',
                                        marginBottom: '2%',
                                        '&:hover': {
                                            background: '#D4273C',
                                        },
                                        textTransform: 'none',
                                    }}
                                        onClick={handleContinue}
                                    >Ok</Button>
                                </Box>
                            }
                        </Box>
                    </Box>
                </Modal>
            )}
        </ScreenView>
    );
})

export default ModalComponent;